import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';

export const useDeleteStage = createMutationHook<void, { pipelineId: string; stageId: string }>({
  mutationFn: ({ pipelineId, stageId }) =>
    apiDelete<void>(operationsClient, jobPipelineEndpoints.stage(pipelineId, stageId)),
  onSuccess: (_data, vars, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.detail(vars.pipelineId) });
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    toast.success('Stage removed');
  },
});
